// extracted by mini-css-extract-plugin
export default {"icon":"BackIcon_icon__Ps9-y","scale":"BackIcon_scale__r-gvy","overlay":"BackIcon_overlay__6zap0"};